import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Backup } from '@/services/configurator/Backup';
import { useEnv } from '@/components/providers/env-provider';
import { PlannerRestoreFromBackupList } from './planner-restore-list';

export type PlannerRestoreDialogProps = {
  name: string;
  backupId: string;
  onRestore: () => void;
  open: PlannerRestoreFromBackupList;
  setRestoreDialogData: React.Dispatch<
    React.SetStateAction<PlannerRestoreFromBackupList>
  >;
};

export function PlannerRestoreDialog(props: PlannerRestoreDialogProps) {
  const { env } = useEnv();
  const { open, setRestoreDialogData } = props;

  return (
    <Dialog
      open={Object.keys(open).length > 0}
      onOpenChange={() => {
        setRestoreDialogData({} as PlannerRestoreFromBackupList);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`Restore ${props.name}?`}</DialogTitle>
          <DialogDescription>
            {`Restore from backup? backupId: ${props.backupId}`}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className='sm:justify-end'>
          <Button
            type='button'
            variant='secondary'
            onClick={() => {
              setRestoreDialogData({} as PlannerRestoreFromBackupList);
            }}
          >
            Cancel
          </Button>
          <Button
            type='button'
            variant='default'
            onClick={() => {
              new Backup(env).restore(props.backupId).then(() => {
                toast.success(`Restored ${props.backupId}`);
                props.onRestore();
              });
              setRestoreDialogData({} as PlannerRestoreFromBackupList);
            }}
          >
            Restore
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
